import fetchServer from "../../fetchServer";

export default async function forgotPin(query) {
  let result = { return: 0, msg: "Something went wrong requesting reset pin!" };

  await fetchServer({ method: "POST", url: "/main/v1/account/resetPin"+(query?`?${query}`:"") })
    .then((res) => {
      if (res?.data && !res?.data?.error) {
        result = { return: 1, msg: "Successful", data: res?.data?.data };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
